<script lang="ts">
  import { icon as iconFn } from '#app/lib/icons'
  import type { ShowErrorOptions } from '#app/modules/redirect'
  import { i18n, I18n } from '#user/lib/i18n'

  const {
    message,
    icon = 'bolt',
    header = I18n('error'),
    context,
    redirection,
    offerToReload = false,
  }: {
    message?: ShowErrorOptions['message']
    icon?: ShowErrorOptions['icon']
    header?: ShowErrorOptions['header']
    context?: ShowErrorOptions['context']
    redirection?: ShowErrorOptions['redirection']
    offerToReload?: boolean
  } = $props()

  function stringify (obj: ShowErrorOptions['context']) {
    if (typeof obj === 'string') return obj
    else return JSON.stringify(obj, null, 2)
  }
</script>

<div class="error-layout">
  <div class="error-box">
    {#if header}
      <h2 class="subheader">
        {#if icon}{@html iconFn(icon)}{/if}
        {header}
      </h2>
    {/if}
    <p>{message}</p>
    {#if context}<pre class="context">{stringify(context)}</pre>{/if}
    {#if redirection}
      <div class="redirection">
        {#if redirection.buttonAction}
          <button class="button radius {redirection.classes}" onclick={redirection.buttonAction}>{redirection.text}</button>
        {/if}
      </div>
    {/if}
    {#if offerToReload}
      <button class="button grey reload" onclick={() => location.reload()}>
        {@html iconFn('undo')} {i18n('Reload')}
      </button>
    {/if}
  </div>
</div>

<style lang="scss">
  @import "general/scss/utils";

  .error-layout{
    text-align: center;
    flex: 1 1 auto;
    min-height: 80vh;
    @include display-flex(column, center, center);
  }
  .error-box{
    background-color: white;
    max-width: 50em;
    margin: 1em;
    @include radius;
    .button{
      font-weight: bold;
    }
    .context{
      background-color: $light-grey;
      opacity: 0.8;
      @include radius;
      padding: 1em;
      margin: 1em 0;
      text-align: start;
      font-size: 0.8em;
      overflow: auto;
    }
  }
  .reload{
    margin-block-start: 1rem;
    :global(.fa-undo){
      transform: scale(-1, 1);
    }
  }

  /* Very small screens */
  @media screen and (width < $very-small-screen){
    .error-box{
      padding: 1em;
    }
  }

  /* Large screens */
  @media screen and (width >= $very-small-screen){
    .error-layout{
      padding-block-end: 10em;
    }
    .error-box{
      padding: 2em 4em;
      h2{
        width: 100%;
        font-size: 1.6em;
        @include text-wrap(nowrap);
      }
    }
    .redirection{
      padding-block-start: 1em;
    }
  }
</style>
